const searchToogle = () => {
    let iconSearch = document.getElementById("iconSearch");
    let inputSearch = document.getElementById("inputSearch");

    
    document.addEventListener("click", function(e) {
        let target = e.target;
        if( inputSearch.classList.contains("active") && target !== iconSearch &&  target !== inputSearch) {
            inputSearch.classList.remove("active");
            iconSearch.classList.remove("active");
        } else if (target == iconSearch  || target.closest('div').classList.contains("search-header") ) {
            inputSearch.classList.toggle("active");
            iconSearch.classList.toggle("active");
            inputSearch.focus();
        }
        
    });
}

export default searchToogle;